export type Rule = (context?: unknown) => Promise<boolean | null>;

export interface Policy {
  can: Rule;
}

export class SimplePolicy implements Policy {
  private rule: Rule;

  constructor(rule: Rule) {
    this.rule = rule;
  }

  public can(ctx?: unknown): Promise<boolean | null> {
    return this.rule(ctx);
  }
}
